// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/commands.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum gdx.connections.public.v1.UserReportSource
 */
export enum UserReportSource {
  /**
   * @generated from enum value: USER_REPORT_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_REPORT_SOURCE_PROFILE = 1;
   */
  PROFILE = 1,

  /**
   * @generated from enum value: USER_REPORT_SOURCE_CHAT = 2;
   */
  CHAT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(UserReportSource)
proto3.util.setEnumType(UserReportSource, "gdx.connections.public.v1.UserReportSource", [
  { no: 0, name: "USER_REPORT_SOURCE_UNSPECIFIED" },
  { no: 1, name: "USER_REPORT_SOURCE_PROFILE" },
  { no: 2, name: "USER_REPORT_SOURCE_CHAT" },
]);

/**
 * @generated from message gdx.connections.public.v1.SendLikeCommand
 */
export class SendLikeCommand extends Message<SendLikeCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<SendLikeCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendLikeCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendLikeCommand {
    return new SendLikeCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendLikeCommand {
    return new SendLikeCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendLikeCommand {
    return new SendLikeCommand().fromJsonString(jsonString, options);
  }

  static equals(a: SendLikeCommand | PlainMessage<SendLikeCommand> | undefined, b: SendLikeCommand | PlainMessage<SendLikeCommand> | undefined): boolean {
    return proto3.util.equals(SendLikeCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendPowerLikeCommand
 */
export class SendPowerLikeCommand extends Message<SendPowerLikeCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<SendPowerLikeCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendPowerLikeCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPowerLikeCommand {
    return new SendPowerLikeCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPowerLikeCommand {
    return new SendPowerLikeCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPowerLikeCommand {
    return new SendPowerLikeCommand().fromJsonString(jsonString, options);
  }

  static equals(a: SendPowerLikeCommand | PlainMessage<SendPowerLikeCommand> | undefined, b: SendPowerLikeCommand | PlainMessage<SendPowerLikeCommand> | undefined): boolean {
    return proto3.util.equals(SendPowerLikeCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.AcceptPowerLikeCommand
 */
export class AcceptPowerLikeCommand extends Message<AcceptPowerLikeCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  constructor(data?: PartialMessage<AcceptPowerLikeCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.AcceptPowerLikeCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPowerLikeCommand {
    return new AcceptPowerLikeCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommand {
    return new AcceptPowerLikeCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommand {
    return new AcceptPowerLikeCommand().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPowerLikeCommand | PlainMessage<AcceptPowerLikeCommand> | undefined, b: AcceptPowerLikeCommand | PlainMessage<AcceptPowerLikeCommand> | undefined): boolean {
    return proto3.util.equals(AcceptPowerLikeCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.CancelPowerLikeCommand
 */
export class CancelPowerLikeCommand extends Message<CancelPowerLikeCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  constructor(data?: PartialMessage<CancelPowerLikeCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.CancelPowerLikeCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPowerLikeCommand {
    return new CancelPowerLikeCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPowerLikeCommand {
    return new CancelPowerLikeCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPowerLikeCommand {
    return new CancelPowerLikeCommand().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPowerLikeCommand | PlainMessage<CancelPowerLikeCommand> | undefined, b: CancelPowerLikeCommand | PlainMessage<CancelPowerLikeCommand> | undefined): boolean {
    return proto3.util.equals(CancelPowerLikeCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.BlockUserCommand
 */
export class BlockUserCommand extends Message<BlockUserCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<BlockUserCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.BlockUserCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockUserCommand {
    return new BlockUserCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockUserCommand {
    return new BlockUserCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockUserCommand {
    return new BlockUserCommand().fromJsonString(jsonString, options);
  }

  static equals(a: BlockUserCommand | PlainMessage<BlockUserCommand> | undefined, b: BlockUserCommand | PlainMessage<BlockUserCommand> | undefined): boolean {
    return proto3.util.equals(BlockUserCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.UnblockUserCommand
 */
export class UnblockUserCommand extends Message<UnblockUserCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<UnblockUserCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.UnblockUserCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnblockUserCommand {
    return new UnblockUserCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnblockUserCommand {
    return new UnblockUserCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnblockUserCommand {
    return new UnblockUserCommand().fromJsonString(jsonString, options);
  }

  static equals(a: UnblockUserCommand | PlainMessage<UnblockUserCommand> | undefined, b: UnblockUserCommand | PlainMessage<UnblockUserCommand> | undefined): boolean {
    return proto3.util.equals(UnblockUserCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ReportUserCommand
 */
export class ReportUserCommand extends Message<ReportUserCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  /**
   * @generated from field: uint32 reason = 3;
   */
  reason = 0;

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: gdx.connections.public.v1.UserReportSource source = 5;
   */
  source = UserReportSource.UNSPECIFIED;

  constructor(data?: PartialMessage<ReportUserCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ReportUserCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(UserReportSource) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportUserCommand {
    return new ReportUserCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportUserCommand {
    return new ReportUserCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportUserCommand {
    return new ReportUserCommand().fromJsonString(jsonString, options);
  }

  static equals(a: ReportUserCommand | PlainMessage<ReportUserCommand> | undefined, b: ReportUserCommand | PlainMessage<ReportUserCommand> | undefined): boolean {
    return proto3.util.equals(ReportUserCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ClearDialogCommand
 */
export class ClearDialogCommand extends Message<ClearDialogCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  constructor(data?: PartialMessage<ClearDialogCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ClearDialogCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearDialogCommand {
    return new ClearDialogCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearDialogCommand {
    return new ClearDialogCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearDialogCommand {
    return new ClearDialogCommand().fromJsonString(jsonString, options);
  }

  static equals(a: ClearDialogCommand | PlainMessage<ClearDialogCommand> | undefined, b: ClearDialogCommand | PlainMessage<ClearDialogCommand> | undefined): boolean {
    return proto3.util.equals(ClearDialogCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RemoveDialogsCommand
 */
export class RemoveDialogsCommand extends Message<RemoveDialogsCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: repeated string connection_ids = 2;
   */
  connectionIds: string[] = [];

  constructor(data?: PartialMessage<RemoveDialogsCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RemoveDialogsCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDialogsCommand {
    return new RemoveDialogsCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDialogsCommand {
    return new RemoveDialogsCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDialogsCommand {
    return new RemoveDialogsCommand().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDialogsCommand | PlainMessage<RemoveDialogsCommand> | undefined, b: RemoveDialogsCommand | PlainMessage<RemoveDialogsCommand> | undefined): boolean {
    return proto3.util.equals(RemoveDialogsCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendMessageCommand
 */
export class SendMessageCommand extends Message<SendMessageCommand> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 3;
   */
  connectionId = "";

  /**
   * @generated from oneof gdx.connections.public.v1.SendMessageCommand.content
   */
  content: {
    /**
     * @generated from field: string text = 4;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: string photo_id = 5;
     */
    value: string;
    case: "photoId";
  } | {
    /**
     * @generated from field: gdx.connections.public.v1.SendMessageCommand.Gift gift = 6;
     */
    value: SendMessageCommand_Gift;
    case: "gift";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SendMessageCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendMessageCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "content" },
    { no: 5, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "content" },
    { no: 6, name: "gift", kind: "message", T: SendMessageCommand_Gift, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageCommand {
    return new SendMessageCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageCommand {
    return new SendMessageCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageCommand {
    return new SendMessageCommand().fromJsonString(jsonString, options);
  }

  static equals(a: SendMessageCommand | PlainMessage<SendMessageCommand> | undefined, b: SendMessageCommand | PlainMessage<SendMessageCommand> | undefined): boolean {
    return proto3.util.equals(SendMessageCommand, a, b);
  }
}

/**
 * Gift which is for sending to the server.
 *
 * @generated from message gdx.connections.public.v1.SendMessageCommand.Gift
 */
export class SendMessageCommand_Gift extends Message<SendMessageCommand_Gift> {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId = "";

  /**
   * @generated from field: string text = 2;
   */
  text = "";

  constructor(data?: PartialMessage<SendMessageCommand_Gift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendMessageCommand.Gift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageCommand_Gift {
    return new SendMessageCommand_Gift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageCommand_Gift {
    return new SendMessageCommand_Gift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageCommand_Gift {
    return new SendMessageCommand_Gift().fromJsonString(jsonString, options);
  }

  static equals(a: SendMessageCommand_Gift | PlainMessage<SendMessageCommand_Gift> | undefined, b: SendMessageCommand_Gift | PlainMessage<SendMessageCommand_Gift> | undefined): boolean {
    return proto3.util.equals(SendMessageCommand_Gift, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.MakeDialogReadCommand
 */
export class MakeDialogReadCommand extends Message<MakeDialogReadCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  constructor(data?: PartialMessage<MakeDialogReadCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.MakeDialogReadCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakeDialogReadCommand {
    return new MakeDialogReadCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakeDialogReadCommand {
    return new MakeDialogReadCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakeDialogReadCommand {
    return new MakeDialogReadCommand().fromJsonString(jsonString, options);
  }

  static equals(a: MakeDialogReadCommand | PlainMessage<MakeDialogReadCommand> | undefined, b: MakeDialogReadCommand | PlainMessage<MakeDialogReadCommand> | undefined): boolean {
    return proto3.util.equals(MakeDialogReadCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DeleteMessagesCommand
 */
export class DeleteMessagesCommand extends Message<DeleteMessagesCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  /**
   * @generated from field: repeated string message_ids = 3;
   */
  messageIds: string[] = [];

  constructor(data?: PartialMessage<DeleteMessagesCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DeleteMessagesCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMessagesCommand {
    return new DeleteMessagesCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMessagesCommand {
    return new DeleteMessagesCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMessagesCommand {
    return new DeleteMessagesCommand().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMessagesCommand | PlainMessage<DeleteMessagesCommand> | undefined, b: DeleteMessagesCommand | PlainMessage<DeleteMessagesCommand> | undefined): boolean {
    return proto3.util.equals(DeleteMessagesCommand, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RequestPhotoCommand
 */
export class RequestPhotoCommand extends Message<RequestPhotoCommand> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<RequestPhotoCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RequestPhotoCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestPhotoCommand {
    return new RequestPhotoCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestPhotoCommand {
    return new RequestPhotoCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestPhotoCommand {
    return new RequestPhotoCommand().fromJsonString(jsonString, options);
  }

  static equals(a: RequestPhotoCommand | PlainMessage<RequestPhotoCommand> | undefined, b: RequestPhotoCommand | PlainMessage<RequestPhotoCommand> | undefined): boolean {
    return proto3.util.equals(RequestPhotoCommand, a, b);
  }
}

